import Component from '../core/Component'
import Typewriter from 'typewriter-effect/dist/core';

export default class TypewriterEncryptedWindow extends Component {


   constructor(element) {
      super(element);

      this.START_DELAY = 600 // delayed start
      this.TIMER = 600 // delay between fields ms
      this.TYPING_SPEED = 40 // ms

      this.replacement = this.element.querySelectorAll(".input-field")

   }

   prepare() {
      setTimeout(() => {


         this.replacement.forEach((el, i) => {
            setTimeout(() => {
               let sentence = el.getAttribute("data-typewriter")
               const typewriter = new Typewriter(el, {
                  autoStart: true,
                  delay: this.TYPING_SPEED,
                  cursor: "",
                  cursorClassName: "typewriter-cursor"
               });

               typewriter
                  .pause(200)
                  .typeString(sentence)
                  .callFunction(this.removeTypewriterCursor)
                  .start()

            }, i * this.TIMER);
         });
      }, this.START_DELAY)
   }

   removeTypewriterCursor() {
      setTimeout(() => {
         document.querySelector(".typewriter-cursor").remove()
      }, 100);
   }

}